<template>
  <b-card class="card border-0 bg-transparent stand-up-animation rounded"
          :img-src="image" img-top>

    <b-row class="card-info px-0 py-3 shadow border" align-v="stretch">
      <b-col cols="12" align-self="start">
        <slot name="p-1"/>
      </b-col>
      <b-col cols="12" align-self="end">
        <slot name="p-2"/>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

export default {
  name: "C100",
  props:['image']
}
</script>

<style scoped>
.card .card-img-top {
  border-radius: 10px 10px 0 0;
}
.card {
  height: 100% !important;
  cursor: pointer;
}
.card-info {
  position: relative;
  background-color: var(--light);
  bottom: 50px;
  border-radius: 10px;
  height: 100%;
}
</style>